interface IStatsItem {
  value: string
  field: string
}

export const PpvStatsItem = ({ value, field }: IStatsItem) => {
  return (
    <div className="bg-card w-full p-6 flex flex-col items-center rounded-lg">
      <h3 className="text-2xl font-semibold text-title text-center">{value}</h3>
      <div className="text-sm font-medium text-text-sub leading-6 text-center">
        {field}
      </div>
    </div>
  )
}
